import {Storage} from './storage';

const LocalStorage = new Storage(window.localStorage);
export {LocalStorage};
